



























import { eq, first, indexOf, shuffle } from 'lodash'
import { Component, Vue } from 'vue-property-decorator'

import initialQuizEntity from '../assets/entities/initial-quiz.json'
import InitialQuizStage from './InitialQuizStage.vue'
import { numberWithCommas } from '@/helpers'
import axios from 'axios'

const LIMIT_TIME_IN_SECOND = 10
const SCORE_PER_SECOND = 0
const SCORE_PER_CORRECT = 1

@Component({
  components: { InitialQuizStage },
})
export default class InitialQuiz extends Vue {
  elapsedTime = 0
  allowedTime = LIMIT_TIME_IN_SECOND

  stages: Array<IInitialQuizStage> = []
  currentStage: IInitialQuizStage | null = null
  scores = 0
  timer = 0

  created() {
    this.initStages()
  }

  mounted() {
    this.timer = setInterval(() => {
      this.elapsedTime += 1
      if (this.elapsedTime > this.allowedTime) {
        this.timeout()
      }
    }, 1000)
  }

  destroyed() {
    clearInterval(this.timer)
  }

  initGame() {
    this.elapsedTime = 0
    this.allowedTime = LIMIT_TIME_IN_SECOND
  }

  initStages() {
    this.initGame()

    this.stages = (shuffle(
      initialQuizEntity.stages,
    ) as unknown) as IInitialQuizStage[]

    this.stages = this.stages.slice(0, 20)

    this.currentStage = first(this.stages) as IInitialQuizStage
  }

  timeout() {
    this.changeStage()
  }

  async gameWasCleared() {
    this.stages = []
    this.currentStage = null
    this.elapsedTime = 0
    this.allowedTime = 0
    clearInterval(this.timer)

    const profile = await this.$swal({
      title: '게임종료!',
      text: `당신의 점수는 ${this.scoresWithComma}점 입니다.`,
      input: 'text',
      inputLabel: '순위에 남길 이름을 입력해주세요.',
      inputValue: '',
      inputPlaceholder: '예) 토박이',
      confirmButtonText: '기록하기',
      showCancelButton: true,
      cancelButtonText: '취소하기',
      inputValidator: (inputValue: string) => {
        if (!inputValue) {
          return '이름을 입력해주세요.'
        }
        return null
      },
    })

    axios
      .post('/game/scores.php', {
        name: profile.value,
        type: 'initial-quiz',
        score: this.scores,
      })
      .then(data => data.data)
      .catch(e => console.error(e))

    this.$emit('onGameExit', {
      reason: 'clear-exit',
    } as GameExit)
  }

  calculateScore(correctScore: number) {
    this.scores += correctScore + this.timerCountDown * SCORE_PER_SECOND
  }

  changeStage() {
    this.initGame()

    const currentStageIndex = this.indexOfCurrentStage
    this.currentStage = this.stages[currentStageIndex + 1] as IInitialQuizStage

    if (!this.currentStage) {
      this.gameWasCleared()
      return
    }
  }

  isEqualStage(value: IInitialQuizStage, other: IInitialQuizStage): boolean {
    return eq(value, other)
  }

  submit() {
    const stage = this.currentStage

    this.$swal({
      icon: stage?.correct ? 'success' : 'error',
      title: stage?.correct ? '정답!' : '오답!',
      confirmButtonText: '확인',
    })

    if (stage?.correct) {
      this.calculateScore(SCORE_PER_CORRECT)
    }

    this.changeStage()
  }

  async confirmExit() {
    const confirm = await this.$swal({
      title: '그만하시겠습니까?',
      text: '그만두면 기록이 남지 않습니다.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '그만두기',
      cancelButtonText: '계속하기',
    })

    if (confirm.isConfirmed) {
      this.$emit('onGameExit', {
        reason: 'self-exit',
      } as GameExit)
    }
  }

  async onEnterKeyPressed() {
    await this.submit()
  }

  get indexOfCurrentStage() {
    return indexOf(this.stages, this.currentStage)
  }

  get timerCountDown() {
    return this.allowedTime - this.elapsedTime
  }

  get scoresWithComma() {
    return numberWithCommas(this.scores)
  }
}
